module.exports = __webpack_public_path__ + "img/linkedin.ae8a30f2.svg";